export const GET_CARTDATA_REQUEST = "GET_CARTDATA_REQUEST";
export const GET_CARTDATA_SUCCESS = "GET_CARTDATA_SUCCESS";
export const GET_CARTDATA_FAILURE = "GET_CARTDATA_FAILURE";

export const ADD_CARTDATA_REQUEST = "ADD_CARTDATA_REQUEST";
export const ADD_CARTDATA_SUCCESS = "ADD_CARTDATA_SUCCESS";
export const ADD_CARTDATA_FAILURE = "ADD_CARTDATA_FAILURE";

export const UPDATE_CARTDATA_REQUEST = "UPDATE_CARTDATA_REQUEST";
export const UPDATE_CARTDATA_SUCCESS = "UPDATE_CARTDATA_SUCCESS";
export const UPDATE_CARTDATA_FAILURE = "UPDATE_CARTDATA_FAILURE";

export const DELETE_CARTDATA_REQUEST = "DELETE_CARTDATA_REQUEST";
export const DELETE_CARTDATA_SUCCESS = "DELETE_CARTDATA_SUCCESS";
export const DELETE_CARTDATA_FAILURE = "DELETE_CARTDATA_FAILURE";